export const SET_SITE_CONTEXT_READY_DATA = 'page/SET_SITE_CONTEXT_DATA [ready]';
export const SET_SITE_CONTEXT_ERROR_DATA = 'page/SET_SITE_CONTEXT_DATA [error]';
export const REDIRECTING_TO_SIGNUP = 'page/REDIRECTING_TO_SIGNUP';
export const RETRIEVE_SITE_CONTEXT = 'page/RETRIEVE_SITE_CONTEXT';
export const SKIP_SITE_CONTEXT_API = 'page/SKIP_SITE_CONTEXT_API';
export const SET_IMPERSONATING_STATE_KEY = 'page/SET_IMPERSONATING_STATE_KEY';
